import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiRequestService, AppMetadataHandler, CommonUtilty, GuidGenerator } from 'app/BaseFramework';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';
import { ClientHandlingService } from 'app/BaseFramework/core/services/clientHandling/client-handling.service';
//import { ClientDO, ClientOrgnizationDO, ClientPersonDO } from 'app/BaseFramework/shared/models';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-register-client-details',
  templateUrl: './register-client-details.component.html',
  styleUrls: ['./register-client-details.component.scss']
})

export class RegisterClientDetailsComponent implements OnInit {

  @Input() captureRole: string;
  @Input() uiConfig: string;

  _clientDataObj = {};
  @Input() set clientDataObj(clientDataObj) {
    if (clientDataObj && clientDataObj['clientDOData']) {
      this._clientDataObj = clientDataObj['clientDOData'];
      this.viewEditClientData();
    }
  }

  @Output() emitSelectedClientList = new EventEmitter<any>();

  constructor(private metadataService: MetadataService,
    private commonUtilty: CommonUtilty,
    private appMetadataHandler: AppMetadataHandler,
    private message: NzMessageService,
    private guidGenerator: GuidGenerator,
    private apiRequest: ApiRequestService,
    private clientHandlingService: ClientHandlingService
  ) {  }

  lookupsToBind = ['clientTypeCd'];
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind);

  baseDOname: string = null;

  ngOnInit(): void {
    this.baseDOname = this.clientHandlingService.baseClientDONode;
    this.checkSearchAddFeature();
    this.getSearchCriteriaList();
    this.getKeyForSelectingData();
  }

  chooseToAddClientBy: string = 'ADD';
  checkSearchAddFeature() {
    if (this.uiConfig && this.uiConfig['allowSearchAdd'] == 'SEARCH') {
      this.chooseToAddClientBy = this.uiConfig['allowSearchAdd'];
    } else {
      this.chooseToAddClientBy = 'ADD';
    }
  }

  keyForSelectingData: string = 'id';
  getKeyForSelectingData() {
    this.keyForSelectingData = this.uiConfig && this.uiConfig['roleType'] == 'AGENT' ? 'agentNum' : 'id';
  }

  /*********Search Existing Client***********/
  CRITERIALOOKUP = [];
  getSearchCriteriaList() {
    if (this.uiConfig && this.uiConfig['searchConfig'] && this.uiConfig['searchConfig']['searchCriteria']) {
      this.metadataService.getSearchCriteriaList(this.uiConfig['searchConfig']['searchCriteria']).subscribe(resp => {
        this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp);
      });
    }
  }

  searchedClientList = [];
  fetchClientResult(data) {
    if (data && this.commonUtilty.isArrayIterable(data.results)) {
      this.searchedClientList = [...data.results];
    } else {
      this.message.info("No matched records found!");
    }
  }

  setOfCheckedId = new Set<number>();
  selectedListOfClientData = [];
  rowSelectionStatusChanged(isChecked: boolean, id: any) {
    if (this.uiConfig && this.uiConfig['searchConfig'] && this.uiConfig['searchConfig']['isSingleSelection']) {
      this.selectedListOfClientData = [];
      this.setOfCheckedId.clear();
    }
    if (isChecked) {
      this.setOfCheckedId.add(id);
      this.selectedListOfClientData.push(this.searchedClientList.filter(item => item[this.keyForSelectingData] == id)[0]);
    } else {
      this.setOfCheckedId.delete(id);
      this.selectedListOfClientData = this.selectedListOfClientData.filter(item => item[this.keyForSelectingData] != id);
    }
  }


  emitSelectedClient() {
    if (this.uiConfig && this.uiConfig['roleType'] == 'AGENT') {
      let url = "agent/fetchByAgentNum/";
      this.fetchClientDOAgentDOforSelectedRecords(url);
    } else {
      let url = `client/fetchById/`;
      this.fetchClientDOAgentDOforSelectedRecords(url);
    }
  }

  fetchClientDOforSelectClientList = [];
  fetchClientDOAgentDOforSelectedRecords(url) {
    const observables = this.selectedListOfClientData.map(data => {
      return this.apiRequest.get(url + data[this.keyForSelectingData]).pipe(
        catchError(error => {
          console.error(`Error fetching client/Agent with ID ${data[this.keyForSelectingData]}:`, error);
          return of(null); // Return a fallback value or an empty response
        })
      );
    }
    );

    forkJoin(observables).subscribe({
      next: (results) => {
        this.fetchClientDOforSelectClientList = results.filter(item => item !== null); // Filter out null responses
        this.emitSelectedClientList.emit(this.fetchClientDOforSelectClientList);
      },
      error: (err) => {
        console.error('An error occurred while fetching client', err);
      }
    });

  }
  /*********END: Search Existing Client***********/

  /**********Add new or Edit existing Client***********/

  clientTypeCd: string = 'PERSON';
  currentAllDynamicComponentData = {};

  addUpdateClientData() {
    this.currentAllDynamicComponentData = this.retainKey(this.currentAllDynamicComponentData, this.clientTypeCd); // Either Person or Organization data to be saved not both.

    let clientData = this.UItoServerTransform(this.currentAllDynamicComponentData);

    if (this.clientTypeCd === 'PERSON') {
      //clientData = new ClientPersonDO();
      clientData.organisationDO = null;
      clientData['personDO'].personIdentityList = this.setIdentityForTheClient();

    } else if (this.clientTypeCd === 'ORGANIZATION') {
      //clientData = new ClientOrgnizationDO();
      clientData.personDO = null;
    }

    clientData['clientTypeCd'] = this.clientTypeCd;
    if (!clientData['guid']) {
      clientData['guid'] = this.guidGenerator.setGuid();
    }

    clientData['clientContactDetailsList'] = this.setPhoneForTheClient();
    clientData['clientEmailList'] = this.setEmailForTheClient();
    clientData['clientAddressList'] = this.setAddressForTheClient();

    this.emitSelectedClientList.emit([clientData]);

  }

  retainKey(jsonObj, keyToRetain) {
    return jsonObj.hasOwnProperty(keyToRetain) ? { [keyToRetain]: jsonObj[keyToRetain] } : {};
  }

  UItoServerTransform(formData) {
    if (!this._clientDataObj) {
      this._clientDataObj = {};
    }

    let flattenedIO = this.commonUtilty.plainflattenObject(this._clientDataObj, 'unsafe', '4');
    let metaData = this.extractMetaData();

    if (flattenedIO && this.commonUtilty.isArrayIterable(metaData.formItems)) {
      metaData.formItems.forEach(field => {
        let comboCondition1 = !!(field.fieldType == 'COMBO' && field.comboMode == 'multiple' && field.comboBindingType == 'CSV');
        let comboCondition2 = !!(field.fieldType == 'COMBOMULTISELECTCSV' || field.fieldType == 'COMBOMULTISELECTENTERABLECSV');

        //check if field exits on form
        if (formData && formData[this.clientTypeCd].hasOwnProperty(field.fieldKey)) {
          if (field.fieldType == 'DATE' && !field.ignoreDateTimeConversion) {
            flattenedIO[field.fieldMapping] = this.dateToEpoch(formData[this.clientTypeCd][field.fieldKey]);
          }
          else if (field.fieldType == 'TIME' && !field.ignoreDateTimeConversion) {
            flattenedIO[field.fieldMapping] = this.commonUtilty.UIDOtoServerDOsetTime(formData[this.clientTypeCd][field.fieldKey]);
          }
          else if (comboCondition1 || comboCondition2) {
            flattenedIO[field.fieldMapping] = this.commonUtilty.convertArrayToCSV(formData[this.clientTypeCd][field.fieldKey]);
          }
          else if (field.fieldType == 'EMPTY') {
            // No Reaction on EMPTY
          }
          else {
            flattenedIO[field.fieldMapping] = formData[this.clientTypeCd][field.fieldKey];
          }
        }
      });
    }
    else {
      console.error("Issue with clint data UItoServerMapping");
    }

    let output = this.commonUtilty.plainUnflattenObject(flattenedIO, 'unsafe', '4');
    return output;
  }

  extractMetaData() {
    let config = null;
    if (this.uiConfig && this.clientTypeCd) {
      switch (this.clientTypeCd) {
        case 'PERSON':
          config = this.uiConfig['personFormConfig'];
          break;

        case 'ORGANIZATION':
          config = this.uiConfig['organizationFormConfig'];
          break;

        default:
          break;
      }
    }
    return config;
  }

  viewEditClientData() {
    if (Object.keys(this._clientDataObj).length > 0) {
      this.serverToUITransform();
      if (this._clientDataObj['clientAddressList']) {
        this.inputClientCaptureAddressDetailsList = this._clientDataObj['clientAddressList'];
      }
      if (this._clientDataObj['clientContactDetailsList']) {
        this.inputClientCapturePhoneDetailsList = this._clientDataObj['clientContactDetailsList'];
      }
      if (this._clientDataObj['clientEmailList']) {
        this.inputClientCaptureEmailDetailsList = this._clientDataObj['clientEmailList'];
      }
      if (this._clientDataObj['personDO'].personIdentityList) {
        this.inputClientCaptureIdentityDetailsList = this._clientDataObj['personDO'].personIdentityList;
      }
    }
  }

  serverToUITransform() {
    let flattenedIO = this.commonUtilty.plainflattenObject(this._clientDataObj, 'unsafe', '4');
    if (!this.currentAllDynamicComponentData) {
      this.currentAllDynamicComponentData = {};
    }
    this.currentAllDynamicComponentData[this.clientTypeCd] = flattenedIO;
  }

  /**********END: Add new or Edit existing Client ***********/

  /**************Client Contact, Email, Address and Identity details***************************/
  phoneList: Array<any> = [];
  emailList: Array<any> = [];
  addressList: Array<any> = [];
  identityList: Array<any> = [];
  inputClientCapturePhoneDetailsList: any = [];
  inputClientCaptureEmailDetailsList: any = [];
  inputClientCaptureAddressDetailsList: any = [];
  inputClientCaptureIdentityDetailsList: any = [];
  isUpdatedPhone: boolean = false;
  isUpdatedEmail: boolean = false;
  isUpdatedAddress: boolean = false;
  isUpdatedIdentity: boolean = false;

  fetchPhoneList(phoneList) {
    this.isUpdatedPhone = true;
    this.phoneList = phoneList.componentData;
  }
  fetchEmailList(emailList) {
    this.isUpdatedEmail = true;
    this.emailList = emailList.componentData;
  }
  fetchAddressList(addressList) {
    this.isUpdatedAddress = true;
    this.addressList = addressList.componentData;
  }
  fetchIdentityList(identityList) {
    this.isUpdatedIdentity = true;
    this.identityList = identityList.componentData;
  }

  setPhoneForTheClient() {
    if (this.isUpdatedPhone == false) {
      return this.inputClientCapturePhoneDetailsList;
    }
    return this.phoneList;
  }
  setEmailForTheClient() {
    if (this.isUpdatedEmail == false) {
      return this.inputClientCaptureEmailDetailsList;
    }
    return this.emailList;
  }
  setAddressForTheClient() {
    if (this.isUpdatedAddress == false) {
      return this.inputClientCaptureAddressDetailsList;
    }
    return this.addressList;
  }
  setIdentityForTheClient() {
    if (this.isUpdatedIdentity == false) {
      return this.inputClientCaptureIdentityDetailsList;
    }
    return this.identityList;
  }
  /**************END: Client Contact, Email, Address and Identity details***************************/

  /************Utility***********/
  getDateString(rawDate) {
    if (rawDate) {
      if (this.commonUtilty.isArrayIterable(rawDate)) {
        return this.commonUtilty.serverDOtoUIDODate(rawDate);
      } else {
        return moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
      }
    }
    else {
      return '-';
    }
  }

  dateToEpoch(date) {
    // Create a Date object from the input date
    if (!date) {
      return null;
    }
    const dateObject = new Date(date);

    // Get the epoch timestamp in milliseconds and convert it to seconds
    const epochTimestamp = Math.floor(dateObject.getTime());

    return epochTimestamp;
  }
  /************END: Utility***********/

}
